import { TChainId } from 'modules/api/chainIDs';
import { DUMMY_CONFIG, NetworkConfig, getEvmConfig } from '../evmConfig';

export function getNetworkConfig(chainId: TChainId): NetworkConfig {
  const networkConfig = getEvmConfig()[chainId];

  if (!networkConfig) {
    console.log(`NetworkConfig for chain ${chainId} is not defined`);
    return DUMMY_CONFIG;
  }

  return networkConfig;
}
